const rankingItems = [
  { rank: 1, title: '我独自升级', tag: '韩漫·系统流', heat: '🔥 586万', trend: 'up', desc: '成振宇从最弱猎人逆袭为暗影君主' },
  { rank: 2, title: '鬼灭之刃', tag: '日漫·少年热血', heat: '🔥 912万', trend: 'up', desc: '炭治郎与鬼杀队的最终决战篇章' },
  { rank: 3, title: '剑道第一仙', tag: '国漫·热血', heat: '🔥 328万', trend: 'up', desc: '苏奕持剑独闯九重天一剑破万法' },
  { rank: 4, title: '全职高手', tag: '国漫·电竞', heat: '🔥 456万', trend: 'stable', desc: '叶修重返荣耀赛场千机伞再现江湖' },
  { rank: 5, title: '某天成为公主', tag: '韩漫·穿越', heat: '🔥 267万', trend: 'up', desc: '希娅公主异世界宫廷权谋逆袭之路' },
  { rank: 6, title: '咒术回战', tag: '日漫·咒术', heat: '🔥 743万', trend: 'down', desc: '虎杖悠仁吞下宿傩手指开启咒术之旅' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门榜单</h2>
          <p className="text-foreground-500 text-sm mt-2">全网热度实时排行，追更不迷路</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer group"
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center font-heading text-lg shrink-0 ${
                item.rank === 1 ? 'bg-secondary-500 text-background-50' :
                item.rank === 2 ? 'bg-foreground-300 text-background-50' :
                item.rank === 3 ? 'bg-primary-300/70 text-primary-800' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1">{item.title}</h3>
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-accent-500 text-xs"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line text-primary-500 text-xs"></i>}
                  {item.trend === 'stable' && <i className="ri-subtract-line text-foreground-400 text-xs"></i>}
                </div>
                <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">{item.desc}</p>
                <div className="flex items-center gap-2 mt-1.5">
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100/70 text-accent-700">{item.tag}</span>
                  <span className="text-[10px] text-foreground-400">{item.heat}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}